import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/home/benning/Desktop/unchai-restaurant/src/app/(marketing)/_components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/benning/Desktop/unchai-restaurant/src/app/(marketing)/_components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollProgress"] */ "/home/benning/Desktop/unchai-restaurant/src/app/(marketing)/_components/ScrollProgress.tsx");
;
import(/* webpackMode: "eager" */ "/home/benning/Desktop/unchai-restaurant/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ClarityAnalytics"] */ "/home/benning/Desktop/unchai-restaurant/src/components/ClarityAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useAdtech"] */ "/home/benning/Desktop/unchai-restaurant/src/lib/adtech/hooks.ts");
;
import(/* webpackMode: "eager", webpackExports: ["AdtechProvider"] */ "/home/benning/Desktop/unchai-restaurant/src/lib/adtech/provider.tsx");
